import * as React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IUserInfo } from '../CustomTypes';

const EmbedHtml: React.FC<{
  html: string;
  query: string;
  userInfo: IUserInfo;
}> = ({ html, query, userInfo }) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const [alteredHtml, setAlteredHtml] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onLoad = useCallback((evt) => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (!loaded || !ref.current) {
      return;
    }

    const { contentDocument: doc } = ref.current;
    const interval = setInterval(() => {
      window.requestAnimationFrame(() => {
        const height = doc.body.offsetHeight;
        if (ref.current) {
          ref.current.height = height.toString();
        }
      });
    }, 200);
    return () => clearInterval(interval);
  }, [loaded, ref]);

  const buildUserInfoObject = () => {
    if (userInfo) {
      return JSON.stringify({
        spidId: userInfo.spidId,
        email: userInfo.email,
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
      });
    }
    return '';
  };

  useEffect(() => {
    const script = `<script>var ffQueryParams = "${query}"; var ffUserData = '${buildUserInfoObject()}';</script>`;
    if (!alteredHtml && userInfo) {
      html = html.concat(script);
      setAlteredHtml(html);
    }
  }, [userInfo, html]);

  if (!alteredHtml) {
    return null;
  }

  return (
    <iframe
      style={{ borderStyle: 'none', width: '100%' }}
      title={'receipt'}
      scrolling="no"
      height="0"
      srcDoc={alteredHtml}
      onLoad={onLoad}
      ref={ref}
    />
  );
};
export default EmbedHtml;
